import { Box, Button, Divider, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import logoImage from "../../Assets/TitleLogo.png"
import { Formik, Form } from 'formik'
import CustomInputLogin from '../../Components/CustomInputLogin/CustomInputLogin'
import CustomDateInput from '../../Components/CustomDate/CustomDateInput'
import CustomDropdownMui from '../../Components/CustomDropDown/CustomDropdown'
import CustoDropDownRegister from '../../Components/CustomDropDown/CustoDropDownRegister'
import { BiCross } from 'react-icons/bi'
import { Cancel, CancelSharp } from '@mui/icons-material'
import * as Yup from "yup"; // Import Yup for validation
import { useNavigate } from 'react-router-dom'
import actions from '../../ReduxStore/actions'
import { useDispatch, useSelector } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import FullPageLoader from '../../Components/FullPageLoader/FullPageLoader'
import CustomEmailVerifyInput from '../../Components/CustomEmailVerifyInput/CustomEmailVerifyInput'
import CustomPhoneVerifyInput from '../../Components/CustomMobileNumber/CustomMobileNumber'
import CustImageUploadInput from '../../Components/ProfileUpload/ProfileUpload'
import { adminUrl } from '../../constants'


const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    date_of_birth: Yup.date().required("Date of birth is required"),
    gender: Yup.string().required("Gender is required"),
    // personal_email_address: Yup.string()
    //     .email("Invalid email format")
    //     .required("Personal email is required"),
    official_email_address: Yup.string()
        .email("Invalid email format")
        .required("Official email is required"),
    // phone_number: Yup.string()
    //     .matches(/^\d{10}$/, "Phone number must be 10 digits")
    //     .required("Phone number is required"),
    present_city: Yup.string().required("Present city is required"),
    Present_address: Yup.string().required("Present address is required"),
    present_state: Yup.string().required("Present state is required"),
    present_country: Yup.string().required("Present country is required"),

    year_of_completion: Yup.number()
        .min(1900, "Year must be valid")
        .max(new Date().getFullYear(), "Year cannot be in the future")
        .required("Year of completion is required"),
    batch: Yup.string().required("Batch is required"),
    campus: Yup.string().required("Campus is required"),
    course: Yup.string().required("Course is required"),
    website: Yup.string().url("Enter a valid URL").nullable(),
    password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    confirm_password: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
});


const RegisterPage = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [isVerified, setIsVerified] = useState(false);

    const [isEmailVerified, setIsEmailVerified] = useState(false);
    const [emailInput, setEmailInput] = useState(""); // Track email input

    const [phoneInput, setPhoneInput] = useState(""); // Track phone number input
    const [viewImgApi, setViewImgApi] = useState(null);

    const { getSiteSettings } = useSelector(
        (state) => state?.getSiteSettings
    );


    const [loading, setLoading] = useState(false);

    const handleRegisterSubmit = async (values, { resetForm }) => {
        setLoading(true)


        console.log(values, "valuesss")

        // const responseData = await axios.put(`${adminUrl}aluminireject/${id}`, { reject_reason: values?.rejectCommend });
        const data1 = {

            data: {
                first_name: values?.first_name,
                last_name: values?.last_name,
                date_of_birth: values?.date_of_birth,
                gender: values?.gender,
                personal_email: values?.personal_email_address,
                official_email: values?.official_email_address,
                phone_no: values?.phone_number,
                present_city: values?.present_city,
                present_country: values?.present_country,
                present_state: values?.present_state,
                present_address: values?.Present_address,
                Year_of_completion: values?.year_of_completion,
                batch: values?.batch,
                campus: values?.campus,
                course: values?.course,
                website_url: values?.website,
                password: values?.password,
                // password_confirmation: values?.confirm_password
                profileImage: values?.viewImgApi,
            },

            method: "post",
            apiName: `registerUser`,
        };

        const responseData = await dispatch(actions.REGISTERPOST(data1));
        console.log(responseData, "reponseDatatata")

        // if (responseData?.payload?.message === "Home section rejected successfully.") {
        if (responseData?.payload?.message === "User registered successfully.") {
            setLoading(false)
            resetForm()
            navigate('/')
            setTimeout(() => {
                toast.success("Registration successful.")
                // onClose()
                // onPreviewModalClose()

            }, 1500)

        } else {
            setLoading(false)

            setTimeout(() => {
                // onPreviewModalClose()
                toast.error(responseData?.payload?.message)


            }, 1500)

        }

    }


    return (
        <div style={{ position: "relative" }}>
            {loading && <FullPageLoader />}

            <Box sx={{ position: "absolute", right: "10px", top: 5 }}>
                <CancelSharp
                    style={{ display: { sx: "none", md: "block" } }}
                    onClick={() => {
                        navigate("/")
                    }}
                />
            </Box>
            <Grid
                item
                size={{ md: 5, xs: 12 }}


                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 2,
                    background: '#FFFFFF',
                    width: '100%',

                }}
            >

                <Box sx={{
                    // display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                    boxShadow: { xs: 0, sm: 4, md: 4 },
                    padding: { xs: 0, sm: 3, md: 3 },
                    width: "100%",
                    // boxShadow: 4,
                    m: 4


                    // border: "1px solid red"
                }}>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Box sx={{ display: "flex", alignItems: "center", flexDirection: { xs: "column", sm: "row", textAlign: { xs: "center" } } }}>
                            <Box
                                component="img"
                                src={`${adminUrl}${getSiteSettings?.data?.logo}`}
                                sx={{ height: 40, width: 150 }}
                            />
                            <Typography variant='h6' fontSize={{ md: "25px", xs: "15px" }} textAlign={{ xs: "center" }}>
                                WeConnect Global {getSiteSettings?.data?.company_name} Network Registration
                            </Typography>
                        </Box>

                    </Box>
                    <Divider sx={{ mt: 2, mb: 2 }} />
                    <Formik
                        initialValues={{
                            first_name: "",
                            last_name: "",
                            date_of_birth: "",
                            gender: "",
                            personal_email_address: "",
                            official_email_address: "",
                            phone_number: "",
                            present_city: "",
                            present_state: "",
                            present_country: "",
                            Present_address: "",
                            year_of_completion: "",
                            profileImage: null,

                            batch: "",
                            campus: "",
                            course: "",
                            website: "",
                            password: "",
                            confirm_password: "",
                        }}
                        validationSchema={validationSchema}
                        onSubmit={handleRegisterSubmit}
                    >
                        {({ handleSubmit, resetForm, setFieldValue }) => (

                            <Form onSubmit={handleSubmit}>
                                < Grid container columnSpacing={4} rowSpacing={2}>
                                    <Grid size={{ xs: 12 }} sx={{ mb: 2 }}>

                                        <CustImageUploadInput
                                            label="Add cover image"
                                            name="profileImage"
                                            // isSubmitting={isSubmitting}
                                            viewImgApi={viewImgApi}
                                            setViewImgApi={setViewImgApi}
                                        // isFinalSubmit={activeStep === steps.length - 1}
                                        // isFormSubmitted={isFor}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="first_name"
                                            label="First Name"
                                            inputType="text"
                                            custPlaceholder="Enter your first name"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="last_name"
                                            label="Last Name"
                                            inputType="text"
                                            custPlaceholder="Enter your last name"
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomDateInput
                                            name="date_of_birth"
                                            label="Date of Birth"
                                            custPlaceholder="Enter your last name"

                                        />

                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustoDropDownRegister
                                            name="gender"
                                            label="Gender"
                                            custPlaceholder="--Select--"
                                            options={[
                                                { label: "Male", value: "male" },
                                                { label: "Female", value: "female" },
                                                { label: "Others", value: "others" },
                                            ]}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        {/* <CustomInputLogin
                                            name="personal_email_address"
                                            label="Personal Email Address"
                                            inputType="email"
                                            custPlaceholder="Enter your Personal Email Address"
                                        /> */}
                                        <CustomEmailVerifyInput
                                            important={true}
                                            setIsVerified={setIsEmailVerified}
                                            isVerified={isEmailVerified}
                                            emailInput={emailInput}
                                            setEmailInput={setEmailInput}
                                            name="personal_email_address"
                                            label="Email ID"
                                            inputType="email"
                                            setFieldValue={setFieldValue}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="official_email_address"
                                            label="Official Email Address"
                                            inputType="email"
                                            custPlaceholder="Enter your Official Email Address"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomPhoneVerifyInput
                                            important={true}
                                            name="phone_number"
                                            label="Mobile Number"
                                            countrycodename="countrycode"
                                            setIsVerified={setIsVerified}
                                            isVerified={isVerified}
                                            phoneInput={phoneInput}
                                            setPhoneInput={setPhoneInput}
                                            custPlaceholder="Enter Mobile Number"
                                            setFieldValue={setFieldValue} // Pass setFieldValue to CustomPhoneVerifyInput
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="present_city"
                                            label="Present City"
                                            inputType="text"
                                            custPlaceholder="Enter your present city"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="present_state"
                                            label="Present State"
                                            inputType="text"
                                            custPlaceholder="Enter your present state"
                                        />
                                    </Grid><Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="present_country"
                                            label="Present Country"
                                            inputType="text"
                                            custPlaceholder="Enter your present country"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="Present_address"
                                            label="Present Address"
                                            inputType="text"
                                            custPlaceholder="Enter your Personal Email Address"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="year_of_completion"
                                            label="Year of Completion"
                                            inputType="number"
                                            custPlaceholder="Enter your year of completion"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="batch"
                                            label="Batch"
                                            inputType="text"
                                            custPlaceholder="Enter your batch"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="campus"
                                            label="Campus"
                                            inputType="text"
                                            custPlaceholder="Enter your campus"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="course"
                                            label="Course"
                                            inputType="text"
                                            custPlaceholder="Enter your course"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="website"
                                            label="Website(optional)"
                                            inputType="text"
                                            custPlaceholder="Enter your website"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="password"
                                            label="Password"
                                            inputType="password"
                                            custPlaceholder="Enter your password"
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <CustomInputLogin
                                            name="confirm_password"
                                            label="Confirm Passord"
                                            inputType="password"
                                            custPlaceholder="Enter your confirm password"
                                        />
                                    </Grid>


                                    <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "end" }}>
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            // onClick={handleGoRegisterComplete}
                                            // sx={{ textTransform: "none", background: "#C38F51", color: "white", borderRadius: "23px" }}
                                            sx={{
                                                // backgroundColor: "#C38F51",
                                                textTransform: "none",
                                                color: "white",
                                                fontSize: "16px",
                                                mr: 2,
                                                // padding: "0px 40px",
                                                padding: { xs: "0px 20px", md: "0px 40px" },

                                                minHeight: "40px",
                                                boxShadow: "none",

                                                // borderRadius: "23px",
                                                background: "var(--main-color) 0% 0% no-repeat padding-box",
                                                "&:hover": {
                                                    backgroundColor: "var(--main-color)",
                                                },
                                            }}
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            variant="contained"
                                            // type="submit"
                                            onClick={() => {
                                                resetForm()

                                            }}
                                            // sx={{ textTransform: "none", background: "#C38F51", color: "white", borderRadius: "23px" }}
                                            sx={{
                                                // backgroundColor: "#C38F51",
                                                textTransform: "none",
                                                color: "black",
                                                fontSize: "16px",
                                                // padding: "0px 40px",
                                                padding: { xs: "0px 20px", md: "0px 40px" },

                                                minHeight: "40px",
                                                // boxShadow: 2,
                                                // border:"1px solid gray",

                                                // borderRadius: "23px",
                                                background: "white 0% 0% no-repeat padding-box",
                                                // "&:hover": {
                                                //     backgroundColor: "#3B4056",
                                                // },
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>

                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </Box>
                <ToastContainer
                    position="top-right"
                    autoClose={1500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark"
                />
            </Grid>
        </div>
    )
}

export default RegisterPage